@if (show) {
  <div
    class="loader"
    role="status"
    aria-busy="true"
    [attr.aria-label]="'LOADING' | translate"
  ></div>
}
